import React, { useCallback, useEffect, useState, useContext } from "react";
import { Controller, useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt, faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import { AddStudentPNG } from "@app/assets";
import {
  Button,
  Input,
  Link,
  ProfileUploader,
  ProfileUpdtaeDialog,
  DeleteChildDialog,
  Layout,
  Toast,
  Icon
} from "@app/components";
import { whiteColor } from "@app/styles";
import {
  FormFlexWrapper,
  FlexWrapper,
  FormGroup,
  ActionsWrapper,
  ActionButton,
  CommonLabel,
  EmptyContainer,
  DefaultMessage,
  FormHeader,
  FormTitle,
  DropdownWrapper,
  SelectCustomStyles,
  Error,
} from "@app/components/commonStyles";
import { capitalize, objectComparision, removeArrEle, stateList, useLocation } from "@app/utils";
import { updateUser, DataService, deleteAccount, getUser, getAddress } from "@app/services";
import { AuthContext } from "@app/providers";
import {
  ButtonContainer,
  ImageContainer
} from "./profile-component";
import AddChildDialog from "@app/modules/addChildDialog";
import EditChild from "../editChildDialog";
import { StudentDetailsWrapper, StudentTableColumn, StudentTableContent, StudentTableContentHolder, StudentTableHeader, StudentTableWrapper } from "../educator/educator-component";
import Select from "react-select/";

export default function ParentUserProfile() {
  const {
    register,
    handleSubmit,
    errors,
    setValue,
    getValues,
    clearErrors,
    control

  }: any = useForm({});
  const { navigate } = useLocation();
  const { userInfo, setUserInfo } = useContext(AuthContext);
  const [userDetails, setUserDetails] = useState(userInfo.userJson);
  const [imageError, setImageError] = useState<boolean>(false);
  const [profileImage, updateProfileImage] = useState<string>();
  const [childDetail, setChildDetail] = useState<any>();
  const [profileData, updateProfileData] = useState<any>();
  const [buttonText, setButtonText] = useState<string>("Save");
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const [showDelete, setShowDelete] = useState<boolean>(false);
  const [showAddChild, setShowAddChild] = useState<boolean>(false);
  const [showEditChild, setshowEditChild] = useState<boolean>(false);
  const [deleteText, setDeleteText] = useState<string>("Unlink");
  const [showToast, setShowToast] = useState(false);
  const [childData, setChildData] = useState<any>();
  const [loading, setLoading] = useState<boolean>(true);
  const [disableButton, setDisableButton] = useState<boolean>(true);
  const [zipError, setZipError] = useState<boolean>(false);
  const [zipServerErr, setZipServerErr] = useState('')
  const [toastMessage, setToastMessage] = useState<any>({
    type: "",
    message: "",
  });
  const [email, setEmail] = useState(userInfo.userJson.email)
  const [firstName, setFirstName] = useState(userInfo.userJson.firstName)
  const [lastName, setLastName] = useState(userInfo.userJson.lastName)

  const assignValuesToForm = useCallback(() => {
    const params: any = {};
    Object.assign(params, {
      sessionToken: userInfo.sessionToken,
      userId: userDetails.userId,
    });
    // console.log(userDetails.userId)
    getUser(params)
      .then((res) => {
        setLoading(false);
        if (res._responseStatus === 1) {
          const user = JSON.parse(res.userJson);
          setUserDetails(user);
          // console.log(userDetails)
          updateProfileImage(user.thumbnailAsset);
          Object.keys(getValues()).map((key: string) => {
            setValue(key, user[key]);
            return key;
          });
        } else if (res.msgCode === "SSN_002") {
          setToastMessage({
            type: "error",
            message: res.msg,
          });
          setShowToast(true);
          setTimeout(() => {
            localStorage.clear();
            setUserInfo(null);
            navigate("/sign-in");
          }, 5000);
        } else {
          setToastMessage({
            type: "error",
            message: res.msg,
          });
          setShowToast(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        setShowToast(true);
        setToastMessage({
          type: "error",
          message: `Something went wrong, Please try again`,
        });
      });
    // eslint-disable-next-line
  }, [getValues, setValue]);


  const UserDetails = () => {
    const params: any = {};
    Object.assign(params, {
      sessionToken: userInfo.sessionToken,
      userId: userDetails.userId,
    });
    getUser(params)
      .then((res) => {
        setLoading(false);
        if (res._responseStatus === 1) {
          const user = JSON.parse(res.userJson);
          setUserDetails(user);
          // console.log(userDetails)
          // updateProfileImage(user.thumbnailAsset);
          // Object.keys(getValues()).map((key: string) => {
          //   setValue(key, user[key]);
          //   return key;
          // });
        } else if (res.msgCode === "SSN_002") {
          setToastMessage({
            type: "error",
            message: res.msg,
          });
          setShowToast(true);
          setTimeout(() => {
            localStorage.clear();
            setUserInfo(null);
            navigate("/sign-in");
          }, 5000);
        } else {
          setToastMessage({
            type: "error",
            message: res.msg,
          });
          setShowToast(true);
        }
      })
  }




  useEffect(() => {
    let values = getValues()
    // console.log(values)
    // setValue("state",selectedState)
    // console.log(selectedState)
     UserDetails();
    // console.log(userDetails)
    updateProfileImage(userInfo.userJson.thumbnailAsset);
    // console.log(userInfo && userInfo.userJson.childDetails) 
    // console.log(userInfo.userJson)
  }, [])

  // useEffect(() => {
  // let data = localStorage.getItem("parentDataSource") || "";
  // if(data){
  //    setShowAddChild(true)
  // }else{
  //   localStorage.clear()
  // }
  // assignValuesToForm();
  // }, [assignValuesToForm]);

  function onSubmit(data: any) {
    if (imageError || zipError) return;
    const comparedObject = objectComparision(userDetails, data);
    const params: any = {};
    Object.assign(params, {
      userId: userDetails.userId,
      userType: userDetails.userType,
      sessionToken: userInfo.sessionToken,
      ...comparedObject,
    });
    if (profileImage && profileImage.length) {
      if (
        profileData &&
        userDetails &&
        userDetails.profileUrl !== profileData.originalAsset
      ) {
        Object.assign(params, {
          profileUrl: profileData.originalAsset,
          mediumThumbnailAsset: profileData.mediumThumbnailAsset,
          smallThumbnailAsset: profileData.smallThumbnailAsset,
          thumbnailAsset: profileData.thumbnailAsset,
        });
      }
    }
    setButtonText("Saving...");
    updateUser(params)
      .then((response: any) => {
        setButtonText("Save");
        if (response._responseStatus === 1) {
          // console.log(response)
          const ParentData: any = {};
          Object.assign(ParentData, {
            ...response.userJson,
            childDetails: userDetails.childDetails,
          });
          const userData: any = { ...userInfo, userJson: ParentData };
          DataService.sendMessage({ key: "userJson", data: userData.userJson });
          localStorage.setItem("userData", JSON.stringify(userData));
          setUserInfo(userData);
          setShowSuccess(true);
          setDisableButton(true);
        } else if (response.msgCode === "SSN_002") {
          setToastMessage({
            type: "error",
            message: response.msg,
          });
          setShowToast(true);
          setTimeout(() => {
            localStorage.clear();
            setUserInfo(null);
            navigate("/sign-in");
          }, 5000);
        } else {
          setShowToast(true);
          setToastMessage({
            type: "error",
            message: response.msg,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        setButtonText("Save");
        setShowToast(true);
        setToastMessage({
          type: "error",
          message: `Something went wrong, Please try again`,
        });
      });
  }

  function onCancel() {
    setValue("firstName", userInfo.userJson.firstName)
    setValue("lastName", userInfo.userJson.lastName)
    setValue("zip", userInfo.userJson.zip)
    setValue("city", userInfo.userJson.city)
    setValue("state", selectedState)
    clearErrors();
    updateProfileData("");
    setImageError(false);
    updateProfileImage(userDetails.thumbnailAsset);
    setDisableButton(true);
  }

  function onDelete(child: any) {
    setChildDetail(child);
    setShowDelete(true);
  }
  function deleteChild() {
    const params: any = {};
    Object.assign(params, {
      userId: userDetails.userId,
      sessionToken: userInfo.sessionToken,
      requestUserId: childDetail.userId,
    });
    setDeleteText("Unlinking...");
    deleteAccount(params)
      .then((res: any) => {
        const response = res;
        setDeleteText("Unlink");
        if (response._responseStatus) {
          const deletedChildIndex: any = userDetails.childDetails.findIndex(
            (child: any) => child.userId === response.childJson.userId
          );
          const remainingChilds = removeArrEle(
            userDetails.childDetails,
            deletedChildIndex
          );
          const parentData: any = {};
          Object.assign(parentData, {
            ...userDetails,
            childDetails: remainingChilds,
          });
          const userData: any = { ...userInfo, userJson: parentData };
          DataService.sendMessage({ key: "userJson", data: userData.userJson });
          localStorage.setItem("userData", JSON.stringify(userData));
          setUserInfo(userData);
          setUserDetails(userData.userJson);
          setShowDelete(false);
          setToastMessage({
            type: "success",
            message: "Child account unlinked successfully",
          });
          setShowToast(true);
        } else if (response.msgCode === "SSN_002") {
          setToastMessage({
            type: "error",
            message: response.msg,
          });
          setShowToast(true);
          setTimeout(() => {
            localStorage.clear();
            setUserInfo(null);
            navigate("/sign-in");
          }, 5000);
        } else {
          setToastMessage({
            type: "error",
            message: response.msg,
          });
          setShowToast(true);
        }
      })
      .catch((err) => {
        console.log(err);
        setDeleteText("Unlink");
        setToastMessage({
          type: "error",
          message: `Something went wrong, Please try again`,
        });
        setShowToast(true);
      });
  }

  function onChange(data: any) {
    if (data.target.value !== userDetails[data.target.name]) {
      setDisableButton(false);
    }
    if (data.target.name === "zip") {
      setValue("city", "");
      setValue("state", "");
      if (data.target.value.length === 5) {
        setZipError(false);
      }
    }
  }
  function Portal() {
    navigate('/linked-child')
  }
  function onZipBlur(data: any) {
    setZipServerErr('')
    if (data.target.value.length !== 5) {
      setZipError(true);
      return;
    }
    setZipError(false);
    getAddress(data.target.value)
      .then((res) => {
        if (res && !res.error) {
          setValue("city", capitalize(res.city));
          clearErrors("city");
          const selectedState = stateList.find(
            (state) => state.value === res.state
          );
          setValue("state", selectedState);
          clearErrors("state");
        } else {
          setZipServerErr(res.error)
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  const selectedState: any = stateList.find(
    (state) => state.value === userDetails.state
  );
  // console.log(selectedState)

  const onStateChange = () => {
    setValue("state", selectedState)
  }

  return (
    <Layout>
      <form onSubmit={handleSubmit(onSubmit)} onChange={onChange}>
        <FormHeader>
          <span className="back-icon" onClick={() => Portal()}>
            <Icon name="backArrow" />
          </span>
          <FormTitle className="justify-center">
            <h3 className="primary-header text-center">My Home Account</h3>
          </FormTitle>
        </FormHeader>
        <FormGroup>
          <ImageContainer>
            <ProfileUploader
              name="thumbnailAsset"
              background={profileImage}
              onUpdateImage={updateProfileImage}
              onUpdateImageData={updateProfileData}
              setImageError={setImageError}
              imageError={imageError}
            />
          </ImageContainer>
          <FormFlexWrapper className="two-child-layout mb-0">
            <div className="child mb-0">
              <Input
                label="First Name"
                placeholder="First Name"
                defaultValue={firstName}
                name="firstName"
                register={register({
                  required: true,
                  validate: (value: any) => {
                    return value.trim().length > 0;
                  },
                })}
                error={errors.firstName && "Please enter First Name"}
              />
            </div>
            <div className="child">
              <Input
                label="Last Name"
                placeholder="Last Name"
                name="lastName"
                defaultValue={lastName}
                register={register({
                  required: true,
                  validate: (value: any) => {
                    return value.trim().length > 0;
                  },
                })}
                error={errors.lastName && "Please enter Last Name"}
              />
            </div>
          </FormFlexWrapper>
          <FormFlexWrapper className="mb-0">
            <div className="child only-child">
              <Input
                label="Zip Code"
                placeholder="Zip Code"
                name="zip"
                type="number"
                defaultValue={userInfo.userJson.zip || ''}
                maxLength={5}
                onChange={onZipBlur}
                register={register({
                  required: true,
                  validate: (value: any) => {
                    return value.trim().length > 0;
                  },
                })}
                error={
                  (errors.zip && "Please enter Zip Code") ||
                  (!errors.zip && zipError && "Please enter valid Zip Code") ||
                  zipServerErr
                }
              />
            </div>
          </FormFlexWrapper>
          <FormFlexWrapper className="two-child-layout mb-0">
            <div className="child mb-0">
              <Input
                label="City"
                placeholder="City"
                name="city"
                defaultValue={userInfo.userJson.city || ''}
                register={register({
                  required: true,
                  validate: (value: any) => {
                    return value.trim().length > 0;
                  },
                })}
                error={errors.city && "Please enter City"}
              />
            </div>
            <div className="child">
              <CommonLabel className="label-color">State</CommonLabel>
              <DropdownWrapper>
                <Controller
                  as={<Select onFocus={() => setDisableButton(false)} />}
                  value="value"
                  name="state"
                  options={stateList}
                  placeholder="State"
                  // render={({ onChange, value }: any) => (
                  //   <Select
                  //     options={stateList}
                  //     onFocus={() => setDisableButton(false)}
                  //     onChange={onStateChange}
                  //     styles={SelectCustomStyles}
                  //     selected={value}
                  //     placeholder="state"
                  //     menuPosition={"fixed"}
                  //     value={value}
                  //   />
                  // )}
                  control={control}
                  rules={{ required: true }}
                  styles={SelectCustomStyles}
                  defaultValue={selectedState}
                />
                {errors.state && <Error>Please select State</Error>}
              </DropdownWrapper>

            </div>
          </FormFlexWrapper>
          <FormFlexWrapper>
            <div className="child only-child">
              <Input
                type="email"
                label="Email Address"
                placeholder="Email Address"
                name="email"
                defaultValue={email}
                register={register()}
                disable={true}
              />
            </div>
          </FormFlexWrapper>
          {/* <FormFlexWrapper>
          <div className="child only-child">
            <div className="d-flex align-items-center">
              <CommonLabel className="flexed alt fs-16">
                {userDetails.childDetails && userDetails.childDetails.length
                  ? `Your Child account(s)`
                  : null}
              </CommonLabel>
              <Link
                style={{
                  pointerEvents: !userDetails['ageVerfiedflag'] ? "none" : 'initial',
                  opacity: !userDetails['ageVerfiedflag'] ? '0.6' : '1'
                }}
                href="#"
                variant="newsecondary"
                onClick={() => setShowAddChild(true)}
              >
                + Add/Link Child(ren)
              </Link>
            </div>
          </div>
        </FormFlexWrapper>
        {userDetails.childDetails
          ? userDetails.childDetails.map((child: any, index: number) => (
            <FormGroup key={index} className="no-border">
              <FlexWrapper className="align-center justify-between row-on-mobile mb-2">
                <StudentType data-tip data-for={`school_${index}`}>
                  <Icon
                    name={child.schoolAccountReg ? "school" : "home"}
                  />
                  <CommonLabel>{child.firstName}</CommonLabel>
                </StudentType>
                <ToolTip
                  id={`school_${index}`}
                  text={
                    child.schoolAccountReg
                      ? "Child with school license code"
                      : "Child without school license code"
                  }
                />
                <ActionsWrapper>
                  <ActionButton
                    className="success"
                    onClick={() => {
                      setshowEditChild(true);
                      setChildData(child);
                    }}
                    data-tip
                    data-for={`edit_${index}`}
                  >
                    <FontAwesomeIcon
                      color={whiteColor}
                      icon={faPencilAlt}
                      size="sm"
                    />
                  </ActionButton>
                  <ToolTip id={`edit_${index}`} text="Edit Child" />
                  <ActionButton
                    className="danger"
                    onClick={() => onDelete(child)}
                    data-tip
                    data-for={`remove_${index}`}
                  >
                    <FontAwesomeIcon
                      color={whiteColor}
                      icon={faTrashAlt}
                      size="sm"
                    />
                  </ActionButton>
                  <ToolTip
                    id={`remove_${index}`}
                    text="Unlink Child Account"
                  />
                </ActionsWrapper>
              </FlexWrapper>
              <FormFlexWrapper className="two-child-layout mb-0">
                <div className="child">
                  <Input
                    label="First Name"
                    disable={true}
                    value={child.firstName}
                  />
                </div>
                <div className="child">
                  <Input
                    label="Last Name"
                    disable={true}
                    value={child.lastName}
                  />
                </div>
              </FormFlexWrapper>
              <Input
                label="Email Address"
                disable={true}
                value={child.email}
              />
            </FormGroup>
          ))
          : null} */}
          <FlexWrapper className="justify-end">
            <Button
              disabled={disableButton}
              variant="text"
              customClass="mr-1 mr-sm-0 mb-sm-1"
              type="button"
              onClick={() => onCancel()}
            >
              Cancel
            </Button>
            <ButtonContainer
              disabled={buttonText === "Saving..." || disableButton}
              style={{ width: "unset" }}
            >
              <Button variant="newsecondary" type="submit">
                {buttonText}
              </Button>
            </ButtonContainer>
          </FlexWrapper>
        </FormGroup>
        <FormGroup>

        {userDetails.childDetails && userDetails.childDetails.length > 0 &&
        <FlexWrapper className="align-center row-on-mobile mb-1">
            <h3 className="primary-header flexed">Child Accounts</h3>
          </FlexWrapper>
        } 
        
          <StudentTableWrapper className="h-unset bordered br-6">
            <StudentTableHeader>
                <StudentTableColumn className="flexed">
                    <CommonLabel className="mb-0 fs-16 ">First Name</CommonLabel>
                </StudentTableColumn>
                <StudentTableColumn className="flexed">
                    <CommonLabel className="mb-0 fs-16">Last Name</CommonLabel>
                </StudentTableColumn>
                <StudentTableColumn className="flexed">
                    <CommonLabel className="mb-0 fs-16">Username</CommonLabel>
                </StudentTableColumn>
                <StudentTableColumn className="flexed">
                    <CommonLabel className="mb-0 fs-16">Password</CommonLabel>
                </StudentTableColumn>
                <StudentTableColumn className="w-8"></StudentTableColumn>
            </StudentTableHeader>
            <StudentTableContentHolder className="no-border">
              <StudentTableContent className={"p-1 "}>

                {userDetails.childDetails && userDetails.childDetails.length
                  ? userDetails.childDetails.map((child: any, index: number) => (
                    <StudentDetailsWrapper key={index}>
                      <StudentTableColumn className="flexed">
                        <p className="m-0 text-ellipsis">{child.firstName}</p>
                      </StudentTableColumn>
                      <StudentTableColumn className="flexed">
                        <p className="m-0 text-ellipsis">{child.lastName}</p>
                      </StudentTableColumn>
                      <StudentTableColumn className="flexed">
                        <p className="m-0 text-ellipsis">{child.email}</p>
                      </StudentTableColumn>
                      <StudentTableColumn className="flexed">
                        <p className="m-0 text-ellipsis">{child.password}</p>
                      </StudentTableColumn>
                      <ActionsWrapper>
                        <ActionButton
                          className="success"
                          onClick={() => {
                            setshowEditChild(true);
                            setChildData(child);
                          }}
                        >
                          <FontAwesomeIcon
                            color={whiteColor}
                            icon={faPencilAlt}
                            size="sm"
                          />
                        </ActionButton>
                        <ActionButton
                          className="danger"
                          onClick={() => onDelete(child)}
                        >
                          <FontAwesomeIcon
                            color={whiteColor}
                            icon={faTrashAlt}
                            size="sm"
                          />
                        </ActionButton>
                      </ActionsWrapper>
                    </StudentDetailsWrapper>
                  )) :
                  // <div className="nochild">No Child(ren) added yet!</div>
                  <EmptyContainer className="without-pos">
                      <DefaultMessage className="mb-1 medium-font">No Child(ren) added yet!</DefaultMessage>
                      <Link
                          style={{
                              pointerEvents: !userDetails['ageVerfiedflag'] ? "none" : 'initial',
                              opacity: !userDetails['ageVerfiedflag'] ? '0.6' : '1'
                          }}
                          href="#"
                          variant="newsecondary"
                          onClick={() => setShowAddChild(true)}
                      >
                          <img style={{opacity: '0.8' }} src={AddStudentPNG} width="50px" onClick={() => setShowAddChild(true)}></img>
                        <span className="kazoo-tertiary-header">Add Child</span>
                      </Link>
                  </EmptyContainer>
                }
              </StudentTableContent>
            </StudentTableContentHolder>
          </StudentTableWrapper>



        </FormGroup>
      </form>

      <div style={{
                pointerEvents: userDetails['ageVerfiedflag'] == 'f' ? "none" : 'initial',
                display: userDetails['ageVerfiedflag'] == 'f' ? 'none' : 'initial'
            }}>
                {userDetails.childDetails && userDetails.childDetails.length != 0 &&
                <div className="mb-3">
                        <h3 className="primary-header">Instructions</h3>
                    <div>
                        <div className="link-align">
                            <ul style={{marginLeft: "12px"}}>
                                <li className="link-align">
                                    <span>You can add more child accounts by clicking </span>
                                    <a className="kazoo-link" onClick={() => setShowAddChild(true)}>here</a>
                                </li>
                                <li className="link-align">
                                    <span>You can sign in to your child’s account by clicking </span>
                                    <a className="kazoo-link" onClick={() => navigate('/sign-in/student')} >here</a>
                                </li>
                            </ul>
                            
                        </div>
                    </div>
                </div>
                }
            </div>

      {showSuccess && (
        <ProfileUpdtaeDialog
          onClose={() => setShowSuccess(false)}
          message="Changes updated successfully"
          addChild={() => ''}
        />
      )}
      {showDelete && (
        <DeleteChildDialog
          // dialogTitle="Confirm Unlink"
          noTitle={true}
          confirmationText="Are you sure you want to unlink the child's account?"
          confirmationMsg="The child account will be unlinked and you will not be able to access the child's information."
          deleteText={deleteText}
          onClose={() => setShowDelete(false)}
          deleteChild={() => deleteChild()}
        />
      )}
      {showAddChild && (
        <AddChildDialog
          onClose={() => setShowAddChild(false)}
          setUserDetails={setUserDetails}
          userDetails={userDetails}
        />
      )}
      {showEditChild && (
        <EditChild
          onClose={() => setshowEditChild(false)}
          childData={childData}
          setUserDetails={setUserDetails}
        />
      )}
      <Toast
        message={toastMessage.message}
        showToast={showToast}
        type={toastMessage.type}
        onClose={() => setShowToast(false)}
      />
      {/* {loading && <Loader />} */}
    </Layout>
  );
}
